<script>
export default {
  name: 'CockpitMatryoshkaItemActionButtons',
  emits: [
    'open-operations',
    'delete',
  ],
};
</script>

<template>
  <div class="action-buttons">
    <BButton
      class="action-button"
      variant="primary"
      @click="$emit('open-operations')"
    >
      <i class="fas fa-list" />
      {{ $t('cockpit.operations') }}
    </BButton>
  </div>
</template>

<style scoped lang="scss">
.action-buttons {
  display: flex;
  gap: 10px;

  .action-button {
    padding: 4px 30px;
    font-size: 15px;

    i {
      margin-right: 4px;
    }
  }
}
</style>
